__turbopack_context__.v({
  "cartDrawerProductsList": "xMoAlq_cartDrawerProductsList",
  "summaryWrapper": "xMoAlq_summaryWrapper",
  "webCartDrawerContent": "xMoAlq_webCartDrawerContent",
  "webContent": "xMoAlq_webContent",
});
